import React, {useContext, useEffect} from "react";
import '../ClientInvoice/ClientInvoice.css'
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import parse from 'html-react-parser';
import './Common.css'

export default () => {//component is used to show addendum
    let Record = useContext(RecordsManagementContext)
    let PageView = useContext(ViewMangementContext)
    let InvoiceType = Record.IV1_PageDetails.InvoiceType
    let IV1_PageDetails
    InvoiceType === undefined ?  IV1_PageDetails = Record.IV2_PageDetails : IV1_PageDetails = Record.IV1_PageDetails
    let addendumRecord = IV1_PageDetails.AddendumData
    let backgroundColor1 = InvoiceType === undefined ? IV1_PageDetails.CompanyBranchAndEstimateInfo.BgColor1 : IV1_PageDetails.BackgroundColor.BgColor1
    let backgroundColor2 = InvoiceType === undefined ? IV1_PageDetails.CompanyBranchAndEstimateInfo.BgColor2 : IV1_PageDetails.BackgroundColor.BgColor2
    let cookie = document.cookie.split('employee_id=')[1]
    const ShowInvoice = () => { // set the page view (either Invoice 1 or 2 )
        Record.setSelectedAddendum('')
        InvoiceType === undefined ?
            PageView.Set('INVOICE_2') : PageView.Set('INVOICE_1')
    }
    const printAddendum = async() => {//used to print addendum in the pdf format
            let Url =`${IV1_PageDetails.PrintAddendum.url}/print_addendum/${Record.SelectedAddendum}.pdf?id=${IV1_PageDetails.PrintAddendum.estimate_id}`
            window.open(Url)
    }
    useEffect(() => {//used to make header of the page sticky.
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });
    const isSticky = (e) => {//when scroll the page the header still shown on the page.
        const header = document.querySelector('.is-sticky');
        const scrollTop = window.scrollY;
        scrollTop  > 0 ? header.setAttribute('style', 'height: 50px; top: 0; border-bottom: #17a2b8 2px solid !important;margin-left: -23px;')  :
            header.setAttribute('style', 'height: 50px; top: 0; border-bottom: 0px;margin-left: -23px;;');
    };
    const buttonData = <svg xmlns="http://www.w3.org/2000/svg" width="36" height="31" fill="currentColor"
                            className="bi bi-arrow-left-square-fill" viewBox="0 0 16 16" onClick={()=>ShowInvoice()}>
        <title>Go To Invoice</title>
        <path d="M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z"/>
    </svg>

    return(
        <div style={{backgroundColor: "#172b4d", backgroundImage:  `linear-gradient(45deg, ${backgroundColor1} 15%, ${backgroundColor2} 85%)`}}>
            <div className='width-wrapper px-4'>
            <table className="table">
                <thead className={"is-sticky addendum_header"} style={{ top: 0,paddingBottom: "3%",marginLeft: "-23px" }}>
                <tr>
                    <th  className="td-main-bost wid-sticky" style={{paddingTop: "0px",width:"18.7%"}} colSpan={4} >
                        <table className="table" >
                            <tbody>
                            <tr >
                                <td style={{float: "left",borderTop:0}}>
                                     {buttonData}
                                </td>
                                <td  style={{float: "right",borderTop:0,paddingLeft:"19px"}}>
                                    <button className='btn btn-dark btn-sm ' onClick={() => printAddendum()}>
                                        <b>PRINT ADDENDUM</b></button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </th>
                </tr>
                </thead>
                <tbody>

                <tr>
                    <td  colSpan={4} className="addendum-body" >
                        {Object.keys(addendumRecord).map((addendum_name,key) => {
                            if (addendumRecord[addendum_name].id == Record.SelectedAddendum){
                                return (
                                   parse(`${addendumRecord[addendum_name].data}`)
                                )
                            }

                        })}
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
        </div>
    )
}